const Theme = {
    accountLeftContainer: 'white',
    accountRightContainer: 'white',
    active: 'gray',
    avatar: '#8e5adf',
    background: 'rgb(56,58,65)',
    backgroundCard: '#e6e6fa',
    backgroundDark: '#2c394c',
    balance: 'white',
    balanceItem: 'black',
    buttonHover: 'black',
    cart: 'rgb(142,90,223)',
    cartRemoveItem: '#dd4a70',
    checkbox: 'black',
    checkboxLabel: 'black',
    darkroom: '#36374f',
    formSectionTitle: 'black',
    headerButtonBackground: 'rgb(255,255,255)',
    headerButtonText: 'rgb(51, 0, 102)',
    itemPage: 'black',
    menuBackground: 'white',
    menuLinkColor: 'black',
    mobileLimit: '800px',
    headerMobileLimit: '1300px',
    accountMobileLimit: '1000px',
    primary: 'rgb(142,90,223)',
    primaryDark: 'rgb(51, 0, 102)',
    primaryText: 'white',
    productCategoryBackground: 'rgb(90, 100, 230)',
    productCategoryBackgroundSelected: 'white',
    secondary: 'rgb(115,137,255)',
    secondaryDark: 'rgb(90, 100, 230)',
    secondaryText: 'black',
    selectLabelText: 'white',
    selectOptionBackground: 'rgb(142,90,223)',
    selectOptionsBackground: 'white',
    selectSelectedBackground: 'black',
    selectSelectedBorder: 'rgb(142,90,223)',
    spinner: 'rgb(115,137,255)',
    step: 'black',
    stepBackgroundActive: 'white',
    stepBackgroundActiveBackground: '#dd4a70',
    stepBackgroundDone: 'rgb(56,58,65)',
    stepBackgroundDoneBackground: 'rgb(142,90,223)',
    stepBackgroundPending: 'rgb(142,90,223)',
    stepBackgroundPendingBackground: 'white',
    stepper: 'white',
    success: '#00b009',
    successDark: '#006e06',
    successDarkText: 'black',
    successText: 'white',
    tertiary: 'rgba(153, 0, 102, 1)',
    tertiaryDark: 'rgba(100, 0, 52, 1)',
    text: 'white',
    toolbar: 'white',
    toolbarBackground: 'white',
    userIcon: 'white',
    warning: '#dd4a70',
    warningDark: '#7a2a3e',
    warningText: 'white',
    whitesmoke: 'rgb(245, 245, 245)',
};

const NuorelleSiivetTheme = {
    accountLeftContainer: 'white',
    accountRightContainer: 'white',
    active: 'gray',
    avatar: '#112A63',
    background: '#F6F4F0',
    backgroundCard: '#e6e6fa',
    backgroundDark: '#2c394c',
    balance: 'white',
    balanceItem: 'white',
    buttonHover: '#C94134',
    cart: 'white',
    cartRemoveItem: '#C94134',
    checkbox: 'black',
    checkboxLabel: 'black',
    darkroom: 'white',
    formSectionTitle: 'black',
    headerButtonBackground: '#112A63',
    headerButtonText: 'white',
    itemPage: 'black',
    menuBackground: 'white',
    menuLinkColor: 'black',
    mobileLimit: '800px',
    headerMobileLimit: '1300px',
    accountMobileLimit: '1000px',
    primary: '#112A63',
    primaryDark: 'rgb(51, 0, 102)',
    primaryText: 'white',
    productCategoryBackground: '#C94134',
    productCategoryBackgroundSelected: 'white',
    secondary: 'rgb(115,137,255)',
    secondaryDark: 'white',
    secondaryText: 'white',
    selectLabelText: 'black',
    selectOptionBackground: '#C94134',
    selectOptionsBackground: '#112A63',
    selectSelectedBackground: '#112A63',
    selectSelectedBorder: '#C94134',
    spinner: '#C94134',
    step: 'black',
    stepBackgroundActive: '#C94134',
    stepBackgroundActiveBackground: 'white',
    stepBackgroundDone: '#a2c03e',
    stepBackgroundDoneBackground: 'white',
    stepBackgroundPending: 'white',
    stepBackgroundPendingBackground: '#112A63',
    stepper: 'white',
    success: '#a2c03e',
    successDark: '#778d2d',
    successDarkText: 'white',
    successText: 'black',
    tertiary: '#112A63',
    tertiaryDark: 'rgba(100, 0, 52, 1)',
    text: 'black',
    toolbar: 'white',
    toolbarBackground: '#112A63',
    userIcon: '#112A63',
    warning: '#C94134',
    warningDark: '#112A63',
    warningText: 'white',
    whitesmoke: 'rgb(245, 245, 245)',
};

export { Theme, NuorelleSiivetTheme };
